import React from "react";
function Header() {
  return (
    <div>
      <nav className="navbar navbar-dark bg-dark sticky-header">
        <a className="navbar-brand" href="#">
          <img
            src={"https://freesvg.org/img/1494779624.png"}
            width="30"
            height="30"
            className="d-inline-block align-top header-image"
            alt=""
          />
          Color Palette Finder
        </a>
      </nav>
    </div>
  );
}

export default Header;
